// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2a397261","988":"5a91e5f0"}[chunkId] + ".chunk.js";
};